__turbopack_context__.v({
  "artwork": "playlist-display-module-scss-module__GaJ_IW__artwork",
  "artworkImage": "playlist-display-module-scss-module__GaJ_IW__artworkImage",
  "artworkThumbnail": "playlist-display-module-scss-module__GaJ_IW__artworkThumbnail",
  "crdImageWrapper": "playlist-display-module-scss-module__GaJ_IW__crdImageWrapper",
  "credits": "playlist-display-module-scss-module__GaJ_IW__credits",
  "descriptionTitle": "playlist-display-module-scss-module__GaJ_IW__descriptionTitle",
  "descriptionWrapper": "playlist-display-module-scss-module__GaJ_IW__descriptionWrapper",
  "mainWrapper": "playlist-display-module-scss-module__GaJ_IW__mainWrapper",
  "noImageSvg": "playlist-display-module-scss-module__GaJ_IW__noImageSvg",
  "playerWrapper": "playlist-display-module-scss-module__GaJ_IW__playerWrapper",
  "sponsorLogo": "playlist-display-module-scss-module__GaJ_IW__sponsorLogo",
});
